import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="collapsible-text"
export default class extends Controller {
  static targets = ["fullText", "truncatedText", "toggleButton"];

  connect() {
    // Initialize based on screen size
    this.checkScreenSize();

    // Listen for resize events to handle orientation changes
    window.addEventListener("resize", this.checkScreenSize.bind(this));
  }

  disconnect() {
    window.removeEventListener("resize", this.checkScreenSize.bind(this));
  }

  toggle() {
    const isExpanded = this.fullTextTarget.classList.contains("block");

    if (isExpanded) {
      // Collapse: show truncated, hide full
      this.fullTextTarget.classList.remove("block");
      this.fullTextTarget.classList.add("hidden");
      this.truncatedTextTarget.classList.remove("hidden");
      this.truncatedTextTarget.classList.add("block");
      this.toggleButtonTarget.textContent = "Read more...";
    } else {
      // Expand: show full, hide truncated
      this.fullTextTarget.classList.remove("hidden");
      this.fullTextTarget.classList.add("block");
      this.truncatedTextTarget.classList.remove("block");
      this.truncatedTextTarget.classList.add("hidden");
      this.toggleButtonTarget.textContent = "Show less";
    }
  }

  checkScreenSize() {
    const isMobile = window.innerWidth < 768; // md breakpoint in Tailwind

    if (isMobile) {
      // On mobile: enable collapsible behavior, start collapsed
      this.element.classList.remove("hidden");
      this.fullTextTarget.classList.remove("block");
      this.fullTextTarget.classList.add("hidden");
      this.truncatedTextTarget.classList.remove("hidden");
      this.truncatedTextTarget.classList.add("block");
      this.toggleButtonTarget.textContent = "Read more...";
    } else {
      // On desktop: show full text, hide controls
      this.element.classList.add("hidden");
    }
  }
}
